import axiosInstance from "./axiosInstance";
import { API_KEY } from "./settings";

export const getPayment = async (payment_id) => {
     const url = `PasarelaMercadoPago/GetPayment/${payment_id}/${API_KEY}`;
     const axios = axiosInstance();
     const res = await axios.get(url);     
     return res.data;
};
